// Block Component Registry
// Maps block types to React components for dynamic rendering

import BlocImage from './BlocImage';
import BlocTeacherNotes from './BlocTeacherNotes';
import BlocQuiz from './BlocQuiz';
import BlocSondage from './BlocSondage';
import BlocMusic from './BlocMusic';

// Registry must match backend BLOC_REGISTRY
export const BLOC_COMPONENTS = {
  'image': BlocImage,
  'teacher_notes': BlocTeacherNotes,
  'quiz': BlocQuiz,
  'sondage': BlocSondage,
  'music': BlocMusic
};

// Get available block types for UI
export const getAvailableBlockTypes = () => Object.keys(BLOC_COMPONENTS);

// Default export for easy importing
export default BLOC_COMPONENTS;
